/** Stable compact identities fit the existing 160-character stored row-key limit. Not a security hash. */
export function orderIdentity(value: string): string {
    value = value || '';
    return [0x811c9dc5, 0x9e3779b9, 0x85ebca6b, 0xc2b2ae35].map(seed => {
        let hash = seed;
        for (let i = 0; i < value.length; i++) {
            hash = Math.imul(hash ^ value.charCodeAt(i), 0x01000193);
            hash ^= hash >>> 13;
        }
        return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
    }).join('');
}

export function optionContributionKey(section: string, contract: string, strategyId?: string): string {
    return section + '|option:' + orderIdentity(contract) + (strategyId ? '|strategy:' + orderIdentity(strategyId) : '');
}
